import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fmtDate } from "@/lib/api";
import { useAuth } from "@/context/AppContext";
import { useSeo } from "@/lib/draft";
import { UfSelect, maskPhone } from "@/components/AuthPanel";

const KINDS = { acesso: "Acesso aos dados", correcao: "Correção", exclusao: "Eliminação", portabilidade: "Portabilidade", revogacao: "Revogação de consentimento" };

export default function MinhaConta() {
  useSeo("Minha conta", null, true);
  const { user, setUser } = useAuth();
  const [f, setF] = useState({ name: user.name || "", state: user.state || "", phone: user.phone || "" });
  const [dsr, setDsr] = useState({ kind: "acesso", details: "" });
  const [list, setList] = useState([]);
  const loadList = () => api.get("/me/data-requests").then((r) => setList(r.data)).catch(() => {});
  useEffect(() => { loadList(); }, []);

  const save = async () => {
    try {
      const { data } = await api.put("/me/profile", f);
      setUser({ ...user, ...data });
      toast.success("Dados atualizados");
    } catch (e) { toast.error(errMsg(e)); }
  };
  const exportData = async () => {
    const { data } = await api.get("/me/export");
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([JSON.stringify(data, null, 2)], { type: "application/json" }));
    a.download = "meus-dados-azuvexa.json";
    a.click();
  };
  const sendDsr = async () => {
    try {
      await api.post("/me/data-requests", dsr);
      toast.success("Pedido registrado");
      setDsr({ kind: "acesso", details: "" });
      loadList();
    } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div className="wrap max-w-3xl space-y-6 py-10">
      <h1 className="text-3xl font-extrabold">Minha conta</h1>
      <section className="card space-y-4" data-testid="account-profile">
        <h2 className="text-lg font-extrabold">Seus dados</h2>
        <p className="text-sm text-[#64748B]">E-mail: <strong>{user.email}</strong></p>
        <div><label className="label">Nome completo</label><input className="field" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="account-name-input" /></div>
        <div className="grid gap-4 sm:grid-cols-2">
          <div><label className="label">Estado</label><UfSelect value={f.state} onChange={(v) => setF({ ...f, state: v })} testid="account-state-select" /></div>
          <div><label className="label">Celular</label><input className="field" value={f.phone} onChange={(e) => setF({ ...f, phone: maskPhone(e.target.value) })} data-testid="account-phone-input" /></div>
        </div>
        <button className="btn-primary" onClick={save} data-testid="account-save-btn">Salvar</button>
      </section>
      <section className="card space-y-4" data-testid="account-privacy">
        <h2 className="text-lg font-extrabold">Privacidade (LGPD)</h2>
        <button className="btn-secondary btn-sm" onClick={exportData} data-testid="account-export-btn">Baixar meus dados</button>
        <div className="grid gap-3 sm:grid-cols-[220px_1fr]">
          <select className="field" value={dsr.kind} onChange={(e) => setDsr({ ...dsr, kind: e.target.value })} data-testid="dsr-kind-select">
            {Object.entries(KINDS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
          </select>
          <input className="field" placeholder="Detalhes (opcional)" value={dsr.details} onChange={(e) => setDsr({ ...dsr, details: e.target.value })} data-testid="dsr-details-input" />
        </div>
        <button className="btn-secondary btn-sm" onClick={sendDsr} data-testid="dsr-submit-btn">Enviar pedido de titular</button>
        {list.map((x) => <p key={x.data_request_id} className="text-sm">{KINDS[x.kind]} · {fmtDate(x.created_at)} · <strong>{x.status}</strong></p>)}
      </section>
    </div>
  );
}
